import React from 'react';
import Button from './Button';

// 1. Agregamos imageUrl como opcional (?) a la interfaz
interface EventCardProps {
    emoji: string;
    title: string;
    date: string;
    location: string;
    price: string;
    badgeText: string;
    variant?: 'primary' | 'secondary' | 'tertiary' | 'warning' | 'default';
    imageUrl?: string; // <--- NUEVA PROPIEDAD
    onClick?: () => void;
}

const EventCard: React.FC<EventCardProps> = ({
                                                 emoji,
                                                 title,
                                                 date,
                                                 location,
                                                 price,
                                                 badgeText,
                                                 variant = 'primary',
                                                 imageUrl, // Recibimos la prop
                                                 onClick
                                             }) => {

    // Mapas de colores para el fondo del emoji (fallback) y los badges
    const bgColors = {
        primary: 'bg-indigo-50 text-indigo-600',
        secondary: 'bg-purple-50 text-purple-600',
        tertiary: 'bg-pink-50 text-pink-600',
        warning: 'bg-orange-50 text-orange-600',
        default: 'bg-gray-50 text-gray-600'
    };

    const badgeColors = {
        primary: 'bg-indigo-100 text-indigo-700',
        secondary: 'bg-purple-100 text-purple-700',
        tertiary: 'bg-pink-100 text-pink-700',
        warning: 'bg-orange-100 text-orange-700',
        default: 'bg-gray-100 text-gray-700'
    };

    return (
        <div
            className="group bg-white rounded-2xl border border-[var(--st-border)] overflow-hidden hover:shadow-lg transition-all duration-300 hover:-translate-y-1 flex flex-col h-full"
            onClick={onClick}
        >
            {/* HEADER DE LA TARJETA (Imagen o Emoji) */}
            <div className="relative aspect-[4/3] overflow-hidden">

                {/* 2. Lógica Condicional: Si hay imagen, la mostramos. Si no, mostramos el Emoji */}
                {imageUrl ? (
                    <img
                        src={imageUrl}
                        alt={title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                ) : (
                    <div className={`w-full h-full flex items-center justify-center text-6xl ${bgColors[variant]}`}>
                        {emoji}
                    </div>
                )}

                {/* Badge (Etiqueta de estado) siempre visible encima */}
                <div className={`absolute top-3 right-3 px-2 py-1 rounded-lg text-xs font-bold uppercase tracking-wider ${badgeColors[variant]}`}>
                    {badgeText}
                </div>
            </div>

            {/* CONTENIDO DE LA TARJETA */}
            <div className="p-5 flex flex-col flex-grow">
                {/* Fecha */}
                <div className="text-xs font-bold text-[var(--st-text-muted)] uppercase tracking-wide mb-2">
                    {date}
                </div>

                {/* Título */}
                <h3 className="font-display text-lg font-bold text-[var(--st-text-primary)] mb-2 line-clamp-2 flex-grow">
                    {title}
                </h3>

                {/* Ubicación */}
                <div className="flex items-start gap-1.5 text-sm text-[var(--st-text-secondary)] mb-4">
                    <svg className="w-4 h-4 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <span className="line-clamp-1">{location}</span>
                </div>

                {/* Footer: Precio y Botón */}
                <div className="mt-auto pt-4 border-t border-[var(--st-border)] flex items-center justify-between">
                    <div>
                        <p className="text-xs text-[var(--st-text-muted)]">Desde</p>
                        <p className="font-bold text-lg text-[var(--st-text-primary)]">{price}</p>
                    </div>

                    {/* Botón "fake" solo visual, ya que toda la card es clickeable */}
                    <div className="w-8 h-8 rounded-full bg-[var(--st-bg-tertiary)] text-[var(--st-text-primary)] flex items-center justify-center group-hover:bg-[var(--st-accent-primary)] group-hover:text-white transition-colors">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" /></svg>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EventCard;